import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Slider from 'react-slick';
import { convertFormatToSeconds } from '../../../../../Utils';
import { SliderContent } from './style';
import { asyncComponent } from '../../../../HOC/withAsyncLoaded';
import { YoutubePlayer } from './YoutubePlayer';

const RepeatWorkout = asyncComponent(() => {
    return import('../../../GymTv/Repeat').then(module => module.default);
});

const LeaderBoardsCarusel = asyncComponent(() => {
    return import('../../../../App/pages/LeaderBoardsCarusel/LeaderBoardsCarusel').then(module => module.default);
});

const WorkoutProgramme = asyncComponent(() => {
    return import('../../../GymTv/WorkoutProgramme').then(module => module.default);
});

const GymTv = asyncComponent(() => {
    return import('../../../GymTv/LiveDisplay').then(module => module.default);
});

export class BetweenSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            secondsLeft: convertFormatToSeconds(props.duration),
            currentSlide: 0,
        };
    }

    componentDidMount() {
        this.startCountdown();
    }

    startCountdown = () => {
        this.countdown = setInterval(() => {
            this.tick();
        }, 1000);
    };

    tick = () => {
        this.setState(prevState => {
            let secondsLeft, currentSlide;
            if (prevState.secondsLeft === 0) {
                secondsLeft = convertFormatToSeconds(this.props.duration);

                if (prevState.currentSlide === this.props.between.length - 1) currentSlide = 0;
                else currentSlide = ++prevState.currentSlide;
                this.slider.slickGoTo(currentSlide, false);

                return {
                    secondsLeft,
                    currentSlide,
                };
            }
            return {
                secondsLeft: --prevState.secondsLeft,
            };
        });
    };

    componentWillUnmount() {
        clearInterval(this.countdown);
    }

    getSettings = () => {
        return {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            lazyLoad: true,
            accessibility: false,
            arrows: false,
            autoplay: false,
            pauseOnHover: false,
            // fade: true,
            beforeChange: (oldIndex, newIndex) =>
                this.setState({
                    secondsLeft: convertFormatToSeconds(this.props.duration),
                    currentSlide: newIndex,
                }),
        };
    };

    render() {
        const {
            getSettings,
            props: { contentTypes, workoutId, workoutIds, leaderboardIds, between, youtubeLinks, currentChannel },
            state: { currentSlide },
        } = this;

        return (
            <Slider ref={slider => (this.slider = slider)} {...getSettings()}>
                {between.map((item, index) => (
                    <SliderContent key={index}>
                        {workoutId &&
                            contentTypes[index] === 0 && (
                                <WorkoutProgramme key={index} isEmbed={true} currentWorkoutId={workoutIds[index]} />
                            )}
                        {workoutId &&
                            contentTypes[index] === 1 && (
                                <GymTv key={index} isEmbed={true} currentWorkoutId={workoutIds[index]} />
                            )}
                        {workoutId &&
                            contentTypes[index] === 2 && (
                                <RepeatWorkout
                                    slideIndex={index}
                                    key={index}
                                    isEmbed={true}
                                    currentWorkoutId={workoutIds[index]}
                                />
                            )}
                        {contentTypes[index] === 3 && (
                            <LeaderBoardsCarusel
                                background={currentChannel.background}
                                isDarkeningLayerApplied={currentChannel.layer}
                                currentLbIds={[...leaderboardIds[index]]}
                            />
                        )}
                        {contentTypes[index] === 4 && (
                            <LeaderBoardsCarusel
                                background={currentChannel.background}
                                isDarkeningLayerApplied={currentChannel.layer}
                                currentLbIds={[...leaderboardIds[index]]}
                            />
                        )}
                        {contentTypes[index] === 5 && (
                            <YoutubePlayer
                                currentSlide={currentSlide}
                                index={index}
                                key={index}
                                url={youtubeLinks[index]}
                            />
                        )}
                    </SliderContent>
                ))}
            </Slider>
        );
    }
}

BetweenSlider.defaultProps = {
    duration: '00:00:00',
    between: { data: [] },
    contentType: 2,
};

BetweenSlider = withRouter(BetweenSlider);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/ChannelDisplay/BetweenSlider.js